import { create } from "zustand";
import { devtools } from "zustand/middleware";

import {
  createPromotionCodeAdapter,
  ValidatePromotionCodeRequest,
} from "@func-core/core/data/adapters";
import { PromotionCodeDTO } from "@func-core/core/domain/view-models/promotion-code-view-model";
import { createSelectors } from "@func-core/core/utils/zustand-selectors";

type PromotionCodeState = {
  promotionCode: PromotionCodeDTO | null;
  isPromotionCodeInitialized: boolean;
  validatePromotionCode: (
    requestBody: ValidatePromotionCodeRequest
  ) => Promise<PromotionCodeDTO | null>;
  resetPromotionCode: () => void;
  initializeFromStorage: () => void;
};

const usePromotionCodeStoreBase = create<PromotionCodeState>()(
  devtools(
    (set) => {
      const adapter = createPromotionCodeAdapter();

      return {
        promotionCode: null,
        isPromotionCodeInitialized: false,

        initializeFromStorage: () => {
          try {
            const storedPromotionCode = adapter.getPromotionCode();
            set(
              { promotionCode: storedPromotionCode, isPromotionCodeInitialized: true },
              false,
              "initializeFromStorage"
            );
          } catch (error) {
            set(
              { promotionCode: null, isPromotionCodeInitialized: true },
              false,
              "initializeFromStorage"
            );
          }
        },

        validatePromotionCode: async (requestBody: ValidatePromotionCodeRequest) => {
          const response = await adapter.validatePromotionCode(requestBody);
          if (!response) return null;

          adapter.savePromotionCode(response);
          set({ promotionCode: response }, false, "validatePromotionCode");

          return response;
        },

        resetPromotionCode: () => {
          adapter.clearPromotionCode();
          set({ promotionCode: null }, false, "resetPromotionCode");
        },
      };
    },
    {
      name: "Promotion Code Store",
      enabled: process.env.NODE_ENV === "development",
    }
  )
);

export const usePromotionCodeStore = createSelectors(usePromotionCodeStoreBase);
